import "../chunk-XTU7I5IS.js";
function isConstructor(f) {
  return typeof f === "function";
}
export {
  isConstructor
};
//# sourceMappingURL=isConstructor.js.map